export default __webpack_public_path__ + "static/ThinkstockPhotos-55844951_article-7221a7619e5ea55f1e0d26d54f6d6f90.jpg";